/** Prevents rapid sign-in ↔ app auto-restore loops after forced logout. */
const SIGNIN_AUTO_RESTORE_COOLDOWN_MS = 3000;
const SIGNIN_AUTO_RESTORE_TS_KEY = 'codemerlin_signin_auto_restore_at';

/** Survives Sign-In remounts during redirect loops so restore is not restarted every flash. */
let signInRestoreStarted = false;

export function isSignInRestoreStarted(): boolean {
  return signInRestoreStarted;
}

export function markSignInRestoreStarted(): void {
  signInRestoreStarted = true;
}

export function clearSignInRestoreStarted(): void {
  signInRestoreStarted = false;
}

export function shouldSkipSignInAutoRestore(): boolean {
  try {
    const raw = sessionStorage.getItem(SIGNIN_AUTO_RESTORE_TS_KEY);
    if (!raw) {
      return false;
    }
    const at = Number(raw);
    return Number.isFinite(at) && Date.now() - at < SIGNIN_AUTO_RESTORE_COOLDOWN_MS;
  } catch {
    return false;
  }
}

export function markSignInAutoRestoreEnded(): void {
  try {
    sessionStorage.setItem(SIGNIN_AUTO_RESTORE_TS_KEY, String(Date.now()));
  } catch {
    // ignore
  }
}

export function clearSignInAutoRestoreCooldown(): void {
  signInRestoreStarted = false;
  try {
    sessionStorage.removeItem(SIGNIN_AUTO_RESTORE_TS_KEY);
  } catch {
    // ignore
  }
}

/** @internal Vitest only */
export function resetSignInRestoreCoordinationForTests(): void {
  clearSignInAutoRestoreCooldown();
}
